<div
  class="flex flex-1 w-full flex-col items-center justify-center gap-4 rounded-lg p-6 text-center"
  [class.text-muted]="severity() === 'info'"
  [class.text-warning]="severity() === 'warn'"
  [class.text-danger]="severity() === 'error'"
  role="status"
  [attr.aria-live]="severity() === 'error' ? 'assertive' : 'polite'"
>
  <i [class]="icon() + ' text-5xl text-tertiary'"></i>

  @if (title(); as titleKey) {
    <p class="text-lg font-semibold">{{ titleKey | transloco }}</p>
  }

  <p class="text-sm text-tertiary">{{ message() | transloco }}</p>

  @if (actionLabel(); as labelKey) {
    <button
      pButton
      type="button"
      severity="contrast"
      (click)="action.emit()"
    >
      <i
        pButtonIcon
        [class]="actionIcon() ?? ''"
      ></i>
      <span pButtonLabel>{{ labelKey | transloco }}</span>
    </button>
  }
</div>
